import { constants } from "../../constants";
import { PxTalk } from "../../types/bwic/PxTalk";
import { numericUtils } from "../../utils/numeric.utils";
import { formatUtils } from "../../utils/format.utils";

interface WalProps {
    colorWal?: string;
    evalPriceTalkWal?: string;
    priceTalks?: PxTalk[];
}
export function Wal({ colorWal, evalPriceTalkWal, priceTalks = [] }: WalProps) {
    let wal: number | null = null;
    if (numericUtils.isNumber(colorWal)) {
        wal = numericUtils.numberOrDefault(colorWal);
    } else if (numericUtils.isNumber(evalPriceTalkWal)) {
        wal = numericUtils.numberOrDefault(evalPriceTalkWal);
    } else {
        const pxTalkWithWal = priceTalks.find(pt => numericUtils.isNumber(pt.wal));
        if (pxTalkWithWal != null) {
            wal = numericUtils.numberOrDefault(pxTalkWithWal.wal);
        }
    }

    return <>{wal == null ? constants.emptyPlaceholder : formatUtils.formatDecimal(wal)}</>
}